var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStargaze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "75px",
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Logo/stargaze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Logo/stargaze",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C1C1D3",
    strokeWidth: 3,
    cx: 28,
    cy: 28,
    r: 26.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0879176,38.5708383 C21.7573301,42.1453406 18.0226311,44.5569891 15.8838205,45.8057838 C13.74501,47.0545786 14.2721343,42.281134 17.4651936,31.4854502 C8.56300103,24.9095104 5.3402805,21.3547923 7.797032,20.8212959 C10.2537835,20.2877996 14.7016885,20.0210514 21.1407471,20.0210514 C24.3789304,11.2136208 26.5013032,6.87419545 27.5078655,7.00277519 C28.5144277,7.13135493 30.3568353,11.4707803 33.0350881,20.0210514 C39.7114465,20.2302193 44.2144281,20.4969675 46.5440328,20.8212959 C48.8736375,21.1456244 48.2068679,22.6770334 44.5437241,25.4155231 L36.7106416,31.4854502 C40.3822689,40.6232729 41.6784375,45.3967174 40.5991476,45.8057838 C39.5198576,46.2148503 35.0161143,43.8032018 27.0879176,38.5708383 Z",
    id: "Star",
    fill: "#C1C1D3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStargaze);
export default __webpack_public_path__ + "static/media/stargaze.9937d0ffbd71e3092e81f5159ddc663d.svg";
export { ForwardRef as ReactComponent };